import { render, staticRenderFns } from "./BirdDogReferralTableFilters.vue?vue&type=template&id=0c80a540&"
import script from "./BirdDogReferralTableFilters.vue?vue&type=script&lang=js&"
export * from "./BirdDogReferralTableFilters.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogReferralTableFilters.vue?vue&type=style&index=0&id=0c80a540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports